import React from 'react';
import { PageHeader, Button } from 'react-bootstrap';
import { toProperCase } from '../../utils/Common';
import { getUser } from '../../utils/Common';
import { CopyToClipboard } from 'react-copy-to-clipboard'; 

export default function AccessControlHeader({ 
  user, 
  builder, 
  history, 
  copied, 
  onCopy, 
  isMobile 
}) {
  return (
    <PageHeader>
      <div className="user-detail-header">
        <Button 
          bsStyle="default"
          onClick={() => history.push(`/accesscontrol/${builder.builderId}`)}
          className="back-button"
          bsSize={isMobile ? "xs" : "large"}
        >
          Return to All Users
        </Button>
        <span className="user-detail-title" style={{ fontSize: isMobile ? '1.2em' : 'inherit' }}>
          {user && `${toProperCase(user.firstName) || user.email.split('@')[0]}'s Settings`}
        </span>
        {getUser().role === 'ADMIN' && !isMobile && (
          <CopyToClipboard text={user.userId} onCopy={onCopy}>
            <Button 
              bsStyle="default"
              style={{ position: 'absolute', right: '15px' }}
            >
              {copied ? 'Copied!' : 'Copy User ID'}
            </Button>
          </CopyToClipboard>
        )}
      </div>
    </PageHeader>
  );
} 